// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useQuery } from "@apollo/client/react";
import { RECEIPT_DOCUMENT } from "../queries/ReceiptDocument";
/** A receipt is a private capability: only its owner may poll or download it. */
export var useReceiptDocument = function (electionEventId, documentId) {
    return useQuery(RECEIPT_DOCUMENT, {
        variables: { electionEventId: electionEventId, documentId: documentId },
        skip: !electionEventId || !documentId,
        fetchPolicy: "no-cache",
        context: { headers: { "x-hasura-role": "cast-vote" } },
    });
};
